import StartRating from "components/StartRating/StartRating";
import React, { FC,useState,useEffect  } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import { Route, Redirect,useHistory,Link,useParams} from 'react-router-dom';
import { Helmet } from "react-helmet";
//import Select, { components } from 'react-select';
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import axios from 'axios'; 

export interface PostBookingChargesProps {
  className?: string;
  DefaultUserID?: string;
}
const PostBookingCharges: FC<PostBookingChargesProps> = (
  {className = "",
  DefaultUserID = localStorage.getItem("user_id") ? localStorage.getItem("user_id") : ""
}) => {

    const params                                                = useParams();
    const history                                               = useHistory();
    const slug                                                  = Object.values(params);
    const [user_id,setUserId]                                   = useState(DefaultUserID);
    const [isdataLoaded, setIsdataLoaded]                       = useState(true);
    const [details,setDetails]                                  = useState({ferry_meals_ticket:"",ferry_ticket:"",meals:"",pets:""});


    const countries = [
      { value: "MG", label: "Madagascar", icon:"https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/assam_fish_curry_with_mee_siam_goreng.jpeg" },
      { value: "UE", label: "Union Européenne", icon: "https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/ferry_for_lazarus.jpg" }
    ];

    const [selectedCountry, setSelectedCountry] = useState(countries[0]);

  const handleChange = (value:any) => {
      setSelectedCountry(value);
  };
  // const Option = (props:any) => (
  //     <components.Option {...props} className="country-option">
  //       <img src={props.data.icon} alt="logo" className="country-logo" />
  //       {props.data.label}
  //     </components.Option>
  //   );

  const SingleValue = ({...props }) => (
      
        <img src={selectedCountry.icon} alt="s-logo" className="selected-logo" />
        
     
    );
    const submitHandler = (event: React.FormEvent<HTMLFormElement>) =>{
      event.preventDefault();
      //const isInvalid = validateInput();
    }
    const validateInput = () => {
      const fields = [
        {
          name: 'ferry_meals_ticket',
          value: details.ferry_meals_ticket,
          message: 'First name should not be blank.'
        },
        {
          name: 'ferry_ticket',
          value: details.ferry_ticket,
          message: 'Last name should not be blank.'
        },
        {
          name: 'emailmeals',
          value: details.meals,
          message: 'Email should not be blank.'
        },
        {
          name: 'pets',
          value: details.pets,
          message: 'Password should not be blank.'
        }
      ];
      const isNotFilled = fields.some(field => {
        if (field.value.trim() === '') {
          //setErrorMsg(field.message);
          //field.name === 'email' ? emailRef.current.focus() : passwordRef.current.focus();
          return true;
        }
        //setErrorMsg('');
        return false;
      });
      return isNotFilled;
    };
   

    useEffect(() => {
      setUserId(localStorage.getItem("user_id"));
      if(DefaultUserID==""){
        //history.push("404");
      }
    }, [DefaultUserID]);

  
  const renderContent = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-5 px-0 sm:p-6 xl:p-5">
        <h2 className="text-3xl lg:text-4xl font-semibold">
        Your booking is confirmed! 🎉
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="package-stap-1">
          <h2 className="text-3xl lg:text-2xl font-semibold mb-3">Choose your ferry & food package</h2>
          <form className="grid grid-cols-1" method="POST" onSubmit={submitHandler}>
          <label className="rad-label">
            <div className="w-100 mx-img-2">
                <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/sweet_and_Sour_fish_with_fried_rice.jpeg"></img>
                <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/ferry_for_lazarus.jpg"></img>
            </div>
            <div className="w-full-selecte"><p>1 x Ferry (two way) and 1 x set meal</p></div>
            <div className="rad-text">
              <div className="selected">
              <Input
                fontClass=""
                sizeClass="h-16 px-4 py-3"
                rounded="rounded-3xl"
                placeholder="Share your thoughts ..."
                type="checkbox"
                className="rad-input"
                name="foodMenu"
              />
                
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 important"
                      name="food_ferry_ticket"
                      id="food_ferry_ticket"
                      autoComplete="off"
                      onChange={event => setDetails({ ...details, ferry_meals_ticket: event.target.value })}
                      >
                      <option value="">Choose</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Select>
                    </span>
                    <b>SGD$20 each</b>
                    <span>Par unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <label className="rad-label">
            <div className="w-100">
              <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/ferry_for_lazarus.jpg"></img>
            </div>
            <div className="w-full-selecte"><p>1 x Ferry (two way)</p></div>
            <div className="rad-text">
              <div className="selected">
              <Input
                fontClass=""
                sizeClass="h-16 px-4 py-3"
                rounded="rounded-3xl"
                placeholder="Share your thoughts ..."
                type="checkbox"
                className="rad-input"
                name="foodMenu"
              />
                
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 important"
                      name="ferry_ticket"
                      id="ferry_ticket"
                      autoComplete="off"
                      onChange={event => setDetails({ ...details, ferry_ticket: event.target.value })}
                      >
                      <option value="">Choose</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Select>
                    </span>
                    <b>SGD$20 each</b>
                    <span>Par unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <label className="rad-label">
            <div className="w-100">
                <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/sweet_and_Sour_fish_with_fried_rice.jpeg"></img>
            </div>
            <div className="w-full-selecte"><p>1 x set meal</p></div>
            <div className="rad-text">
              <div className="selected">
              <Input
                fontClass=""
                sizeClass="h-16 px-4 py-3"
                rounded="rounded-3xl"
                placeholder="Share your thoughts ..."
                type="checkbox"
                className="rad-input"
                name="foodMenu"
              />
                
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 important"
                      name="meals"
                      id="meals"
                      autoComplete="off"
                      onChange={event => setDetails({ ...details, meals: event.target.value })}
                      >
                      <option value="">Choose</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Select>
                    </span>
                    <b>SGD$20 each</b>
                    <span>Par unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <label className="rad-label">
          <div className="w-100 font-100-mid">
            <i className="svg-box-dog">
            <svg width="88" height="100" viewBox="0 0 88 114" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M58.1806 43.7256C58.3097 44.1682 58.4388 44.5002 58.531 44.8506C59.1949 47.5986 59.9326 50.3282 60.4675 53.0946C61.8876 60.3058 62.3118 67.5538 60.8917 74.8019C60.0249 79.2835 58.8261 83.7098 57.6642 88.1361C55.9305 94.8124 55.4141 101.507 56.8711 108.294C56.9633 108.755 57.0002 109.124 57.6642 109.179C60.3753 109.475 60.9839 110.157 61.1499 112.942C61.1499 112.997 61.2052 113.034 61.2605 113.126C64.8016 113.126 68.3426 113.126 71.9943 113.126C71.9943 112.038 71.9205 111.005 72.0127 109.972C72.2156 107.446 70.4635 105.989 68.3057 105.823C67.5865 105.768 67.3836 105.436 67.236 104.864C65.9266 99.7182 65.9635 94.5727 67.1623 89.4455C68.1582 85.2406 69.4123 81.0909 70.4267 76.8859C72.4185 68.6235 72.8058 60.3242 70.7586 51.9696C69.2832 45.9387 68.6192 39.8157 69.0803 33.6005C69.2832 30.7787 69.818 28.0491 71.4226 25.6516C72.0865 24.6741 72.9349 23.9733 74.0415 23.4384C76.6419 22.2027 79.2239 20.8933 81.6953 19.3994C82.7834 18.7355 83.6687 18.4404 84.9043 18.7724C85.5683 18.9568 86.4535 18.8461 87.099 18.551C88.1503 18.0715 88.1318 17.1125 87.1175 16.5223C86.5458 16.1904 85.9187 15.9875 85.2732 15.7108C85.3838 15.3235 85.5129 14.9731 85.5867 14.6227C85.9002 13.1288 86.306 11.635 86.4904 10.1226C86.7671 7.89105 86.0293 7.02423 83.8346 6.67382C83.4473 6.61849 83.0416 6.56316 82.6543 6.52627C80.3674 6.28652 78.062 6.0652 75.7751 5.807C74.4472 5.65946 73.3591 5.14306 72.4738 4.03648C70.9984 2.21063 68.9881 1.1225 66.7012 0.624546C61.9798 -0.408257 57.2031 -0.0578418 52.6477 1.19628C46.6169 2.85614 41.9693 6.72914 38.3913 11.8378C38.0594 12.3173 37.8381 12.8706 37.6352 13.4055C37.1741 14.5674 37.3401 15.6371 38.2807 16.5223C41.8217 19.8605 45.7501 22.7191 49.955 25.1905C50.6928 25.6147 51.2276 25.4671 51.7071 24.8401C53.6436 22.3134 54.6211 19.6023 53.4776 16.4301C52.7399 14.4198 52.3711 12.3358 52.6293 10.178C52.869 8.18613 53.7358 6.56316 55.5248 5.12461C55.3219 5.71479 55.2113 6.0652 55.1006 6.41562C54.3629 8.66565 53.994 10.9526 54.5104 13.3133C54.7686 14.512 55.1191 15.6924 55.4695 16.8727C56.3178 19.6207 55.9305 22.1659 54.4551 24.6372C52.6293 27.6987 51.412 28.1598 48.2398 26.5553C46.6353 25.7438 45.0677 24.8216 43.4631 23.9364C43.3709 24.2499 43.2972 24.545 43.2234 24.8401C41.1762 32.7705 38.3176 40.3505 33.8175 47.2482C30.3687 52.5229 26.219 57.2074 22.0878 61.9287C16.7209 68.0702 11.4278 74.2302 6.68799 80.8696C4.4564 83.9864 2.59367 87.3062 1.45021 90.9763C-0.892037 98.4826 -0.560064 105.694 3.94 112.425C4.30886 112.979 4.67772 113.2 5.34166 113.2C7.73924 113.163 10.1368 113.163 12.5344 113.182C18.5099 113.237 24.4485 112.979 30.3502 112.038C34.5737 111.356 38.4282 109.899 41.5451 106.893C44.8832 103.702 46.5247 99.8105 46.1927 95.1444C45.8607 90.5521 42.8176 86.6238 38.4836 85.3328C34.6474 84.1893 30.9773 84.6873 27.6022 86.8082C24.762 88.5787 23.0837 91.1976 22.5858 94.4989C22.4013 95.7346 23.1206 96.6936 24.2088 96.8965C25.3153 97.0994 26.4219 96.417 26.5879 95.2366C27.0674 91.5849 30.2949 89.0029 34.4814 88.8554C37.709 88.7263 40.3647 90.3124 41.5082 93.0972C42.6516 95.919 42.3197 98.6486 40.8442 101.249C38.9446 104.569 35.9569 106.505 32.3421 107.409C26.3297 108.921 20.1882 109.05 14.0283 109.124C13.4565 109.124 13.4012 108.829 13.3274 108.386C12.7373 104.735 12.4606 101.065 12.811 97.376C13.3643 91.7509 15.2455 86.6976 18.8972 82.3266C21.9218 78.7118 25.6473 75.9638 29.7969 73.8244C33.5409 71.9064 37.3954 70.228 41.1578 68.3653C42.4672 67.7198 43.7029 66.8899 44.9017 66.0231C45.4181 65.6542 45.7316 65.0271 46.1742 64.4739C45.5841 64.1788 45.1783 63.9759 44.7726 63.7546C42.3566 62.3345 41.0471 60.232 40.9918 57.4287C40.918 54.2565 42.2459 51.656 44.5328 49.5167C45.0308 49.0556 45.2521 48.5945 45.289 47.9306C45.3259 47.156 45.4365 46.3814 45.5472 45.4777C46.2111 45.9203 46.7829 46.2338 47.2439 46.658C48.7009 47.9859 50.3608 48.5392 52.2973 48.2257C52.7768 48.1519 53.3116 48.0044 53.6805 47.7093C55.1559 46.4183 56.6129 45.0904 58.1806 43.7256ZM50.4346 53.7954C50.4346 54.7729 51.0247 55.5844 51.7624 55.6028C52.537 55.6213 53.1641 54.8098 53.1641 53.777C53.1641 52.8179 52.5555 51.9696 51.8362 51.9511C51.0801 51.9142 50.4346 52.7811 50.4346 53.7954ZM45.5472 53.7954C45.5472 53.0024 45.0492 52.2831 44.4591 52.3569C43.666 52.4491 43.4447 53.0393 43.4078 53.7401C43.3709 54.5516 43.832 55.2155 44.4406 55.234C45.0308 55.2524 45.5287 54.6069 45.5472 53.7954ZM47.5575 56.5434C46.5247 56.5434 45.6763 56.5434 44.6804 56.5434C45.1046 57.4287 45.455 58.1479 45.8792 59.0332C46.4878 58.1479 46.9857 57.3918 47.5575 56.5434Z" fill="white"/>
              <path d="M58.1806 43.7256C56.6129 45.1088 55.1559 46.4183 53.6621 47.6724C53.3116 47.9675 52.7584 48.115 52.2788 48.1888C50.3423 48.5023 48.6825 47.949 47.2255 46.6211C46.7644 46.197 46.1742 45.8834 45.5287 45.4408C45.4365 46.3445 45.3074 47.1191 45.2705 47.8937C45.2521 48.5577 45.0123 49.0187 44.5144 49.4798C42.2275 51.6192 40.918 54.2012 40.9733 57.3918C41.0287 60.1951 42.3381 62.3161 44.7541 63.7177C45.1414 63.939 45.5656 64.1419 46.1558 64.437C45.7132 64.9903 45.3996 65.6173 44.8832 65.9862C43.6844 66.8346 42.4672 67.6645 41.1393 68.3284C37.377 70.1912 33.504 71.8695 29.7785 73.7875C25.6288 75.9269 21.9034 78.6749 18.8787 82.2897C15.2271 86.6607 13.3459 91.7325 12.7926 97.3391C12.4422 101.028 12.7004 104.698 13.309 108.35C13.3828 108.792 13.4381 109.087 14.0098 109.087C20.1513 108.995 26.3112 108.866 32.3236 107.372C35.9384 106.468 38.9262 104.532 40.8258 101.212C42.3012 98.6301 42.6332 95.8821 41.4897 93.0604C40.3647 90.2755 37.7089 88.6894 34.463 88.8185C30.2765 88.966 27.0489 91.548 26.5694 95.1997C26.4219 96.3801 25.3153 97.0625 24.1903 96.8596C23.0837 96.6752 22.3645 95.6977 22.5673 94.462C23.0653 91.1423 24.762 88.5419 27.5838 86.7713C30.9588 84.6504 34.629 84.1524 38.4651 85.2959C42.7992 86.5869 45.8423 90.5152 46.1742 95.1075C46.5062 99.7736 44.8648 103.665 41.5266 106.856C38.3913 109.862 34.5368 111.319 30.3318 112.001C24.4301 112.96 18.473 113.2 12.5159 113.145C10.1184 113.126 7.72079 113.126 5.32322 113.163C4.65927 113.182 4.29041 112.942 3.92156 112.389C-0.578512 105.675 -0.910484 98.4641 1.43176 90.9579C2.57522 87.2877 4.43796 83.968 6.66955 80.8512C11.4094 74.2117 16.7209 68.0334 22.0694 61.9103C26.2006 57.1889 30.3502 52.486 33.7991 47.2298C38.2991 40.3321 41.1578 32.7521 43.2049 24.8216C43.2787 24.5266 43.3709 24.2315 43.4447 23.9179C45.0677 24.8032 46.6169 25.7253 48.2214 26.5368C51.3936 28.1414 52.6108 27.6803 54.4367 24.6188C55.9121 22.1474 56.2994 19.6023 55.451 16.8543C55.0822 15.674 54.7502 14.4936 54.492 13.2948C53.9756 10.9526 54.3444 8.64722 55.0822 6.39718C55.1928 6.04677 55.3035 5.7148 55.5063 5.10618C53.7174 6.54473 52.8506 8.18614 52.6108 10.1595C52.3526 12.3174 52.7399 14.383 53.4592 16.4117C54.6211 19.6023 53.6436 22.3134 51.6887 24.8216C51.2092 25.4487 50.6743 25.5962 49.9366 25.1721C45.7316 22.7007 41.8217 19.8605 38.2622 16.5039C37.3216 15.6186 37.1557 14.5489 37.6167 13.387C37.8196 12.8522 38.0409 12.2805 38.3729 11.8194C41.9508 6.69227 46.5984 2.8377 52.6293 1.17784C57.1847 -0.0762744 61.9614 -0.426689 66.6827 0.606113C68.9697 1.10407 70.9799 2.17376 72.4554 4.01805C73.3406 5.12462 74.4288 5.64102 75.7567 5.78857C78.0436 6.04677 80.3305 6.26808 82.6358 6.50784C83.0416 6.54473 83.4289 6.60006 83.8162 6.65538C86.0293 7.0058 86.7486 7.87262 86.472 10.1042C86.2875 11.6165 85.8818 13.1104 85.5683 14.6043C85.4945 14.9547 85.3654 15.3051 85.2547 15.6924C85.8818 15.969 86.5273 16.1719 87.099 16.5039C88.1134 17.0941 88.1503 18.0531 87.0806 18.5326C86.4351 18.8277 85.5498 18.9384 84.8859 18.7539C83.6502 18.422 82.765 18.717 81.6768 19.381C79.2239 20.8749 76.6419 22.1843 74.023 23.42C72.9164 23.9548 72.0681 24.6557 71.4041 25.6331C69.7811 28.0307 69.2647 30.7418 69.0619 33.582C68.6008 39.7973 69.2832 45.9203 70.7402 51.9511C72.7689 60.3058 72.4 68.5866 70.4082 76.8675C69.3939 81.0725 68.1213 85.2221 67.1438 89.4271C65.945 94.5542 65.9081 99.7183 67.2176 104.845C67.3651 105.436 67.568 105.749 68.2873 105.804C70.4451 105.989 72.1972 107.427 71.9943 109.954C71.9205 110.987 71.9759 112.02 71.9759 113.108C68.3242 113.108 64.7647 113.108 61.2421 113.108C61.1868 113.034 61.1499 112.979 61.1314 112.923C60.9654 110.157 60.3568 109.475 57.6457 109.161C57.0002 109.087 56.9633 108.718 56.8527 108.276C55.3957 101.489 55.9121 94.794 57.6457 88.1177C58.7892 83.6914 59.988 79.2651 60.8732 74.7835C62.2933 67.5354 61.8691 60.2873 60.449 53.0762C59.8958 50.3097 59.158 47.5802 58.5125 44.8322C58.4388 44.5002 58.3097 44.1498 58.1806 43.7256ZM63.7688 9.51403C65.1704 7.68819 66.8487 6.93203 69.0988 8.00172C68.1951 6.93203 67.2176 6.21275 65.8528 6.6185C64.5065 7.02424 63.9532 8.13082 63.7688 9.51403Z" fill="black"/>
              <path d="M50.4345 53.7954C50.4345 52.7811 51.08 51.9143 51.8362 51.9511C52.5555 51.9696 53.1641 52.818 53.1641 53.777C53.1641 54.8098 52.537 55.6213 51.7624 55.6028C51.0247 55.5844 50.4345 54.7914 50.4345 53.7954Z" fill="black"/>
              <path d="M45.5472 53.7954C45.5472 54.6069 45.0492 55.234 44.4406 55.2155C43.8504 55.1971 43.3709 54.5331 43.4078 53.7217C43.4447 53.0393 43.666 52.4307 44.459 52.3384C45.0308 52.3016 45.5472 53.0024 45.5472 53.7954Z" fill="black"/>
              <path d="M47.5575 56.5434C46.9857 57.3918 46.4878 58.1295 45.8791 59.0332C45.455 58.148 45.1045 57.4287 44.6804 56.5434C45.6763 56.5434 46.5246 56.5434 47.5575 56.5434Z" fill="black"/>
              </svg>
              </i>
           </div>
            <div className="w-full-selecte"><p>1 x set Pets</p></div>
            <div className="rad-text">
              <div className="selected">
              <Input
                fontClass=""
                sizeClass="h-16 px-4 py-3"
                rounded="rounded-3xl"
                placeholder="Share your thoughts ..."
                type="checkbox"
                className="rad-input"
                name="Pets"
              />
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 important"
                      name="pets"
                      id="pets"
                      autoComplete="off"
                      onChange={event => setDetails({ ...details, pets: event.target.value })}
                      >
                      <option value="">Choose</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Select>
                    </span>
                    <b>SGD$20 each</b>
                    <span>Par unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <div className="text-right">
          <ButtonPrimary>Continue </ButtonPrimary>
          </div>
          </form>
        </div>

<div className="border-b border-neutral-200 dark:border-neutral-700"></div>

<div className="package-stap-2">
<h2 className="text-3xl lg:text-2xl font-semibold">
Total number of ferry tickets: 04
        </h2>

<div className="flex gap-4 mt-3 date-time-row">
<div>
  <p className="flex font-bold  date-pup items-center"><span>Check in date</span> <input type='date'></input> </p>
  <p className="select-sm-box"><span>2pm at Marina South Pier to Lazarus Island :</span> <select><option>1 ticket</option><option>2 ticket</option><option>3 ticket</option></select> </p>
  </div>
  <div className="pl-0">
  <p className="flex font-bold  date-pup items-center"><span>Check out date</span> <input type='date'></input> </p>

  <p className="select-sm-box"><span>11.30am at Lazarus Island to Marina South Pier :</span> <select><option>1 ticket</option><option>2 ticket</option><option>3 ticket</option></select> </p>
  </div>

</div>
  </div>

  <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
  <div className="package-stap-3">
<h2 className="text-2xl lg:text-2xl font-semibold">
Total number of meals: 4
        </h2>
        
  <div className="row-meal-page mb-2">
      <div className="img_meal"><img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/assam_fish_curry_with_mee_siam_goreng.jpeg"></img></div>
      <div className="mane_meal"><p>1 x Ferry (two way) and 1 x set meal </p>
      <b>SGD$20 each</b>
               <span>Par unit</span></div>
      <div className="selec_meal"><select><option>1 ticket</option> <option>2 ticket</option></select> </div>
  </div>
        
  <div className="row-meal-page mb-2">
      <div className="img_meal"><img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/ferry_for_lazarus.jpg"></img></div>
      <div className="mane_meal"><p>1 x Ferry (two way)</p> <b>SGD$15 each</b>
               <span>Par unit</span> </div>
      <div className="selec_meal"><select><option>1 ticket</option> <option>2 ticket</option></select> </div>
  </div>
       
  <div className="row-meal-page mb-2">
      <div className="img_meal"><img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/sweet_and_Sour_fish_with_fried_rice.jpeg"></img></div>
      <div className="mane_meal"><p>1 x set meal </p> <b>SGD$7 each</b>
               <span>Par unit</span></div>
      <div className="selec_meal"><select><option>1 ticket</option> <option>2 ticket</option></select> </div>
  </div>
       
  <div className="row-meal-page mb-2">
      <div className="img_meal"><img src="https://www.lifespan.org/sites/default/files/styles/featured_image_large/public/lifespan-files/images/blog-images/health-beneiftis-of-pets-900x600.jpg?h=b69e0e0e&itok=PFpteD0N"></img></div>
      <div className="mane_meal"><p>1 x set Pets </p>   <b>SGD$30 each</b>
               <span>per unit</span></div>
      <div className="selec_meal"><select><option>1 ticket</option> <option>2 ticket</option></select> </div>
  </div>
  </div>
        {/* ------------------------ */}
        

        {/* ------------------------ */}
        
        <div className="text-right">
          <ButtonPrimary href="/">Continue  </ButtonPrimary>
        </div>
      </div>
    );
  };
  const renderskeletonLoader = () => {
    return (
      <div className="custom-loader gap-3 justify-center lg:flex-row">
        <div className="border-neutral-200 sm:border sm:rounded-2xl w-70-1 w-70-loader">
          <div className="card m-2">
            <div className="card-body">
              <div className="row mb-5">
                <div className="col-12">
                  <div className="p-3 bg-grey skeleton"></div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-3">
                  <div className="p-5 bg-grey skeleton"></div>
                  <div className="p-2 bg-grey skeleton"></div>
                </div>
                <div className="col-8">
                  <div className="p-2 bg-grey mb-2 skeleton"></div>
                  <div className="p-2 bg-grey mb-2 skeleton"></div>
                  <div className="p-2 bg-grey mb-4 skeleton"></div>
                  <div className="p-2 bg-grey mb-2 skeleton"></div>
                </div>
              </div>
        <div className="row mb-3"></div>
        <div className="gap-3 mb-4 row">
          <div className="border-neutral-200 col-6 p-2.5 sm:border sm:rounded-2xl">
            <div className="p-2 bg-grey mb-2 skeleton"></div>
            <div className="p-2 bg-grey mb-0 skeleton"></div>
          </div>
          <div className="border-neutral-200 col-6 p-2.5 sm:border sm:rounded-2xl">
            <div className="p-2 bg-grey mb-2 skeleton"></div>
            <div className="p-2 bg-grey mb-0 skeleton"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <div className="bg-grey h-6 mb-3 p-2 skeleton"></div>
          </div>
        </div>
        <div className="row"><div className="col-3 mr-40">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        <div className="col-3 p-1">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        </div>
        <div className="row"><div className="col-3 mr-40">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        <div className="col-3">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        </div>
        <div className="row">
          <div className="col-3 mr-40">
            <div className="bg-grey mb-3 p-1 skeleton"></div>
          </div>
        <div className="col-3">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        </div>
        <div className="row">
          <div className="col-3">
            <div className="bg-grey h-6 mb-3 p-2 skeleton"></div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </div>
    );
  }

  return (
    <div className={`nc-PostBookingCharges ${className}`} data-nc-id="PostBookingCharges">
      <Helmet title="Tiny Away | Payment Success"></Helmet>
      {isdataLoaded  ?
        <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
           {renderContent()}
           <div className=" w-2/3 pl-4 sm-full">
    <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 
    dark:border-neutral-700 space-y-3 px-0 sm:p-6 xl:p-3 padding-box-20">
      <h2 className="text-3xl lg:text-2xl font-semibold mb-3">
      Our Booking Details
      </h2>
      <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="mt-15 img-text-detail-bokking">
        <NcImage src="https://pictures.tinyaway.com/filters:format(jpg)/fit-in/960x720/Listings/Images/2023/01/437/m9zvxq2gaotuoxgarecl1673053962322.jpg"/>

<div className="box-detail-boking">
          <p className="mb-2"><b>Kawal Tiny House</b></p>
          <p className="flex items-center space-x-3  mb-2"> <span>1 beds · 1 baths</span></p>
          <p className="flex items-center space-x-3  mb-2"> <span>Check In - 2023-05-09</span></p>
          <p className="flex items-center space-x-3  mb-2"><span> Check Out - 2023-05-10</span></p>
          <p className="flex items-center space-x-3  mb-2"><span>Guests - 2 Guests</span></p>
        </div>
        </div>
      </div>
        </div>
         
        </main>
      :
        <main className="container mt-11 mb-24 lg:mb-32 ">
        {renderskeletonLoader()}
        </main>
      }
      
    </div>
  );
};

export default PostBookingCharges;
